import React, {useState} from 'react';
import {connect} from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";

import {AccessRights, PARTS} from "../../../schemas/accessRightsModel";
import SvgIcons from "../../Icons/SvgIcons";
import MarkUpModal from "../Popups/MarkUpModal/MarkUpModal";

const GlobalMarkUpButton = (props) => {
  const { AR } = props;
  const [markUpModalOpened, setMarkUpModalOpened] = useState(false);

  if(!AR.v(PARTS.HEADER_BUTTON_MARKUP_RETAIL) && !AR.v(PARTS.HEADER_BUTTON_MARKUP_COST) && !AR.v(PARTS.HEADER_BUTTON_MARKUP_DISCOUNT))
    return null;

  const markUpClick = () => {
    setMarkUpModalOpened(!markUpModalOpened);
  }

  const disabled = false;



  return (
    <div className="header-mark-button">
      <button className={"ui-button5 ui-button5--flex ui-button5--flex-icon-left ui-button5--gray " +
        "ui-button5--gray-new" + (disabled ? " ui-button5--disabled" : "")}
              onClick={markUpClick}>
        <div className="ui-button-icon">
          {SvgIcons.upDown}
        </div>
        <span className="ui-button5__text">
          <FormattedMessage id="dashboard.header.globalMarkButton"/>
        </span>
      </button>
      <MarkUpModal isGlobal={true} isOpened={markUpModalOpened} closeModal={markUpClick}/>
    </div>
  )
};

const mapStateToProps = (store) => {
  return {
    AR: AccessRights.get(store)
  }
};

const mapDispatchToProps = {

};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(GlobalMarkUpButton)
)
